import React from "react";
import PageTitle from "../PageTitle";
import { doRequest } from "../../helper";
import $ from "jquery";
import { NavLink } from "react-router-dom";
import LazyLoad from "react-lazyload";
import axios from "axios";
export default class Rb2020 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      response: null,
      popup: false,
      postCount: 0,
      status: "Active",
      setPopup: false,
      selectValue: "",
      searchByValue: "nominee_name",
      lastEvaluatedKey: "",
      loadMoreDisplay: false,
      moveToParty: null,
    };
    this.update = this.update.bind(this);
    this.getPosts = this.getPosts.bind(this);
    this.batchUpdate = this.batchUpdate.bind(this);
    this.selectToggle = this.selectToggle.bind(this);
  }
  componentDidMount() {
    var status = this.props.match.params.status;
    if (!status) {
      status = "enabled";
    }

    this.getPosts(status);
  }
  componentWillReceiveProps(nextProps) {
    var status = nextProps.match.params.status;
    if (!status) {
      status = "enabled";
    }
    this.getPosts(status);
  }
  getPosts(status, loadmore) {
    $("#loader").css({ display: "block" });
    var ref = this;
    if (!loadmore) {
      ref.setState({ items: [] });
    }

    var request = doRequest(
      "cms-operations2",
      {
        action: "list-posts",
        module: "kamalpushpa",
        model: "post",
        lastEvaluatedKey: ref.state.lastEvaluatedKey,
        data: {
          direction: "desc",
          status: status,
          limit: 100,
        },
      },
      true
    );
    request.addEventListener("load", function () {
      var response = this.responseText;
      try {
        response = JSON.parse(response);
        if (response._resultflag && response._resultflag == 1) {
          console.log(ref.state.items);
          console.log(response.Count);
          let loadMoreItems = loadmore
            ? [...ref.state.items, ...response.items]
            : response.items;
          console.log(loadMoreItems);
          if (response.items.length > 99) {
            ref.setState({
              loadMoreDisplay: true,
            });
          } else {
            ref.setState({
              loadMoreDisplay: false,
            });
          }
          ref.setState(
            {
              response: response,
              items: loadMoreItems,
              lastEvaluatedKey: response.lastEvaluatedKey,
              postCount: response.countdata.Count,
              status: status,
            },
            () => {
              $("#loader").css({ display: "none" });
            }
          );
        }
      } catch (ex) { }
    });
  }
  batchUpdate(status) {
    var ids = [];
    var createds = [];
    $(".multi_select:checked").each(function () {
      ids.push($(this).attr("data-id"));
      createds.push($(this).attr("data-created"));
    });
    var id = ids.join(",");
    var created = createds.join(",");

    if (id == "") {
      alert("No post selected");
    } else {
      this.update(id, created, status);
    }
  }
  update(id, created, status) {
    id = "" + id;
    var request = doRequest(
      "cms-operations2",
      {
        action: "update-post",
        module: "kamalpushpa",
        model: "post",
        data: {
          id: id,
          status: status,
          created: created,
        },
      },
      true
    );

    request.addEventListener("load", function () {
      var response = this.responseText;
      try {
        response = JSON.parse(response);
        if (response._resultflag && response._resultflag == 1) {
          var ids = id.split(",");
          ids.map(function (id_value) {
            $("#post_" + id_value).hide();
          });
        }
      } catch (ex) { }
    });
  }

  searhByValueChangeHandler = (e) => {
    this.setState({
      searchByValue: e.target.value,
    });
  };

  loadMoreData = () => {
    let ep = null;
    var status = this.props.match.params.status;
    if (this.input1.value) {
      ep = {
        action: "search-name",
        module: "kamalpushpa",
        model: "post",
        data: { value: this.input1.value, type: this.state.searchByValue },
      };
      if (ep) {
        let lastEvaluatedKey = this.state.lastEvaluatedKey;
        if (lastEvaluatedKey) {
          ep["lastEvaluatedKey"] = lastEvaluatedKey;
        }
        ep["limit"] = 100;
        if (!status) {
          status = "enabled";
        }
        let ref = this;
        var request = doRequest("cms-operations2", ep, true);
        request.addEventListener("load", function () {
          var response = this.responseText;
          try {
            response = JSON.parse(response);
            if (response._resultflag && response._resultflag == 1) {
              console.log(response.Count);
              if (response.items.length > 99) {
                ref.setState({
                  loadMoreDisplay: true,
                });
              } else {
                ref.setState({
                  loadMoreDisplay: false,
                });
              }
              ref.setState(
                {
                  response: response,
                  items: [...this.state.items, ...response.items],
                  lastEvaluatedKey: response.lastEvaluatedKey,
                  postCount: response.countdata.Count,
                  status: status,
                },
                () => {
                  $("#loader").css({ display: "none" });
                }
              );
            }
          } catch (ex) { }
        });
      }
    } else {
      this.getPosts(status, "loadmore");
    }
  };

  enterPressed = (event, field) => {
    console.log(this.state.searchByValue);

    var code = event.keyCode || event.which;
    if (code === 13) {
      $("#loader").css({ display: "block" });
      let ep = null;
      if (field == 1 && this.input1.value) {
        ep = {
          action: "search-name",
          module: "kamalpushpa",
          model: "post",
          data: { value: this.input1.value, type: this.state.searchByValue },
        };
      } else if (field == 2 && this.input2.value) {
        ep = {
          action: "search-message",
          module: "kamalpushpa",
          model: "post",
          data: { value: this.input2.value, type: this.state.searchByValue },
        };
      }

      if (ep) {
        var status = this.props.match.params.status;
        // let lastEvaluatedKey = this.state.lastEvaluatedKey;
        // if (lastEvaluatedKey) {
        //   ep["lastEvaluatedKey"] = lastEvaluatedKey;
        // }
        ep["limit"] = 100;
        if (!status) {
          status = "enabled";
        }
        let ref = this;
        var request = doRequest("cms-operations2", ep, true);
        request.addEventListener("load", function () {
          var response = this.responseText;
          try {
            response = JSON.parse(response);
            if (response._resultflag && response._resultflag == 1) {
              console.log(response.Count);
              if (response.items.length === 0) {
                $("#nodatafound").css({ display: "block" });
              }
              if (response.items.length > 99) {
                ref.setState({
                  loadMoreDisplay: true,
                });
              } else {
                ref.setState({
                  loadMoreDisplay: false,
                });
              }
              ref.setState(
                {
                  response: response,
                  items: response.items,
                  lastEvaluatedKey: response.lastEvaluatedKey,
                  postCount: response.countdata.Count,
                  status: status,
                },
                () => {
                  $("#loader").css({ display: "none" });
                }
              );
            }
          } catch (ex) { }
        });
      }
    }
  };

  selectToggle() {
    if ($(".allChecked").length > 0) {
      $(".multi_select").prop("checked", false);
      $(".multi_select").removeClass("allChecked");
    } else {
      $(".multi_select").prop("checked", true);
      $(".multi_select").addClass("allChecked");
    }
  }

  getData = (obj) => {
    this.setState(
      {
        Data: obj,
        userId: obj.id,
        created: obj.created,
        selectValue: obj.category ? obj.category : "",
      },
      () => {
        this.setState({ popup: true });
      }
    );
  };

  moveToParty = async (userData) => {
    if (!userData) {
      alert('Please select a card for move.');
      return false

    }
    let text = "Are you sure you want to move to party ?";
    if (window.confirm(text) == true) {
      let data = {

        name: userData.name,
        dob: userData.dob,
        gender: userData.gender,
        state: userData.state,
        district: userData.district,
        contact: userData.contact,
        user_type: userData.user_type,
        your_profimg: userData.your_profimg,
        nominee_profimg: userData.nominee_profimg,
        nominee_name: userData.nominee_name,
        nominee_dob: userData.nominee_dob,
        nominee_gender: userData.nominee_gender,
        nominee_state: userData.nominee_state,
        nominee_destrict: userData.nominee_destrict,
        nominee_city: userData.nominee_city,
        nominee_active_year: userData.nominee_active_year,
        nominee_post: userData.nominee_post,
        nominee_level: userData.nominee_level,
        nominee_description: userData.nominee_description
          ? userData.nominee_description
          : "<p></p>",
        nominee_potos: userData.nominee_potos ? userData.nominee_potos : "[]",
        nominee_links: userData.nominee_links ? userData.nominee_links : "[]",
        nominee_work_videos: userData.nominee_work_videos
          ? userData.nominee_work_videos
          : "[]",
        sessionid: Date.now(),
        status: userData.status ? userData.status : "OK",
        disabled: userData.disabled ? userData.disabled : 0,
        userid: userData.userid ? userData.userid : "",
        user_name: userData.user_name ? userData.user_name : "",
        user_name_display: userData.user_name_display
          ? userData.user_name_display
          : "",
        nominee_yourself_video: userData.nominee_yourself_video
          ? userData.nominee_yourself_video
          : "",
        user_avatar: userData.user_avatar ? userData.user_avatar : "",
        user_email: userData.user_email ? userData.user_email : "",
        canvasImage: userData.canvasImage,
        platform: userData.platform ? userData.platform : "pwa",
        search_nominee_name: userData.nominee_name.toLowerCase(),
        search_user_name: userData.name.toLowerCase(),
        moved: "1"
      };


      var params = JSON.stringify({
        action: "save-newforinertdata",
        data: data,
      });
      $("#loader").css({ display: "block" });

      var xhr = new XMLHttpRequest();

      xhr.open(
        "POST",
        "https://campaign-api.narendramodi.in/kamal_pushp_official",
        true
      );
      // xhr.setRequestHeader("Content-Type", "application/json");

      xhr.send(params);

      xhr.addEventListener("load", function () {
        $("#loader").css({ display: "none" });
        var response = JSON.parse(this.responseText);
        if (response && response._resultflag == 1) {
          alert("Record moved successfully.");
        }
      });


    }
  };

  getPopup = (obj) => {
    console.log("obj is ", obj);
    this.setState({ userId: obj.id, created: obj.created }, () => {
      this.setState({ setPopup: true });
    });
  };

  submitForm = async (e) => {
    e.preventDefault();
    let newData = {};
    let postData = {};
    if (this.state.selectValue && this.state.userId) {
      newData = {
        id: this.state.userId,
        created: this.state.created,
        category: this.state.selectValue,
      };

      var data = JSON.stringify({
        action: "update",
        data: newData,
      });

      var xhr = new XMLHttpRequest();

      xhr.open(
        "POST",
        "https://campaign-api.narendramodi.in/kamal-pushpa",
        true
      );
      // xhr.setRequestHeader("Content-Type", "application/json");

      xhr.send(data);

      xhr.addEventListener("load", function () {
        var response = JSON.parse(this.responseText);
        if (response && response._resultflag == 1) {
          alert("Record updated successfully.");
        }
      });
    } else {
      alert("Please select a category");
    }

    // let response = await axios.post(
    //   "https://campaign-api.narendramodi.in/kamal-pushpa",
    //   data
    // );
  };
  render() {
    var bread = "RB 2020 / Moderation (Active Posts)";
    var pagelink = "/rb2020/moderation";
    if (this.props.match.params.status == "disabled") {
      bread = "RB 2020/ Moderation (Disabled Posts)";
      pagelink += "/disabled";
    } else {
      pagelink += "/enabled";
    }
    var items = this.state.items;
    var links = [
      {
        link: "/kamalpushpa/moderation/disabled",
        name: "View Disabled Posts",
      },
      {
        link: "/kamalpushpa/moderation/enabled",
        name: "View Active Posts",
      },
    ];
    var pagination = [];
    if (this.state.response && countdata) {
      var countdata = this.state.response.countdata;
      var pages = Math.ceil(countdata.Count / this.state.limit);

      for (var i = 1; i <= pages; i++) {
        pagination.push(
          <span key={i}>
            <NavLink to={pagelink + "/" + i} className="btn btn-primary btn-xs">
              {i}
            </NavLink>
            &nbsp;
          </span>
        );
      }
    }

    return (
      <div>
        <PageTitle
          title="RB 2020"
          bread={bread}
          links={links}
          Count={this.state.postCount}
          counttype={
            this.state.status == "enabled"
              ? "Active "
              : this.state.status == "disabled"
                ? "Inactive "
                : ""
          }
        />
        <div className="wrapper wrapper-content">
          <div className="media-body ">
            {this.props.match.params.status != "disabled" ? (
              <a
                className="btn btn-warning btn-xs"
                onClick={() => {
                  this.batchUpdate("disable");
                }}
                type="button"
              >
                <i className="fa fa-times"></i>&nbsp;Disable All Checked
              </a>
            ) : (
              <a
                className="btn btn-primary btn-xs"
                onClick={() => {
                  this.batchUpdate("enable");
                }}
                type="button"
              >
                <i className="fa fa-check"></i>&nbsp;Enable All Checked
              </a>
            )}
            &nbsp;&nbsp;
            <a href="javascript:void(0);" onClick={this.selectToggle}>
              <i className="fa fa-check"></i>&nbsp;Select All Toggle
            </a>
            <span style={{ position: "relative", top: "5px" }}>
              &nbsp; Page : {pagination}
              &nbsp;&nbsp;
            </span>
            <div className="form-inline form_right">

              <div>
                <button style={{ color: 'white', backgroundColor: '#1c84c6', borderRadius: '20px', marginRight: '10px' }} onClick={() => this.moveToParty(this.state.moveToParty)}>
                  Move to Party
                </button>
                <label htmlFor="username">Search By Username</label>
                <input
                  type="radio"
                  id="username"
                  className="form-control"
                  name="searchBy"
                  value="user_name"
                  style={{
                    marginRight: "30px",
                    position: "relative",
                    bottom: "3px",
                  }}
                  onChange={this.searhByValueChangeHandler}
                />
                <label htmlFor="nomineename">Search By Nominee Name</label>
                <input
                  type="radio"
                  id="nomineename"
                  className="form-control"
                  name="searchBy"
                  value="nominee_name"
                  style={{
                    marginRight: "30px",
                    position: "relative",
                    bottom: "3px",
                  }}
                  onChange={this.searhByValueChangeHandler}
                  defaultChecked
                />
                <input
                  className="form-control"
                  type="text"
                  ref={(input1) => {
                    this.input1 = input1;
                  }}
                  placeholder="Search By Name "
                  onKeyPress={(e) => {
                    this.enterPressed(e, "1");
                  }}
                />

                {/* <input
                  className="form-control"
                  type="text"
                  ref={(input2) => {
                    this.input2 = input2;
                  }}
                  placeholder="Search By Message "
                  onKeyPress={(e) => {
                    this.enterPressed(e, "2");
                  }}
                /> */}
                <button
                  className="btn-success"
                  onClick={() => {
                    window.location.reload();
                  }}
                >
                  Clear filters
                </button>
              </div>
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-lg-12">
              <div className="kamal_list">
                <p
                  id="nodatafound"
                  style={{
                    display: "none",
                    textAlign: "center",
                    position: "relative",
                    left: "50%",
                    transform: "translateX(-50%)",
                  }}
                >
                  No Data Found
                </p>
                {Array.isArray(items) &&
                  items.map((value, index) => {
                    return (
                      <div class="file-box" key={index} id={"post_" + value.id}>
                        <div class="file">
                          <a href="javascript:void(0);">
                            <span class="corner"></span>
                            <LazyLoad>
                              <div class="image" style={{ height: "auto" }}>
                                {!value.social_post_type ? (
                                  <img
                                    alt="image"
                                    class="img-responsive"
                                    src={value.canvasImage}
                                  />
                                ) : (
                                  <div style={{ height: "100px" }}>
                                    {value.social_post_link}
                                  </div>
                                )}
                                <div className="image_caption">
                                  {value.disabled == 0 ? (
                                    <a
                                      href="javascript:void(0);"
                                      className="btn btn-warning btn-circle"
                                      onClick={() => {
                                        this.update(
                                          value.id,
                                          value.created,
                                          "disable"
                                        );
                                      }}
                                      type="button"
                                    >
                                      <i className="fa fa-times"></i>
                                    </a>
                                  ) : (
                                    <a
                                      href="javascript:void(0);"
                                      className="btn btn-info btn-circle "
                                      onClick={() => {
                                        this.update(
                                          value.id,
                                          value.created,
                                          "enable"
                                        );
                                      }}
                                      type="button"
                                    >
                                      <i className="fa fa-check"></i>
                                    </a>
                                  )}
                                </div>
                                <a
                                  href="javascript:void(0);"
                                  style={{
                                    position: "absolute",
                                    top: "0px",
                                    left: "0px",
                                    height: "25px",
                                    width: "25px",
                                  }}
                                  className="btn btn-info btn-circle "
                                  type="button"
                                >
                                  <input
                                    data-created={value.created}
                                    data-id={value.id}
                                    type="checkbox"

                                    style={{ margin: "2px", position: 'relative', top: '-13px' }}
                                  />
                                </a>
                              </div>
                            </LazyLoad>
                            <div style={{ position: "relative", left: "40px" }}>
                              <label
                                style={{
                                  position: "relative",
                                  top: "-15px",
                                  marginRight: "30px",
                                }}
                                htmlFor={value.id}
                              >
                                Move to Party
                              </label>
                              <input
                                // value={Object.fromEntries(Object.entries(value))}
                                onClick={(e) =>
                                  this.setState({ moveToParty: value })
                                }
                                type="radio"
                                name="party"
                                id={value.id}
                              />
                            </div>

                            <div class="file-name">
                              <span
                                onClick={() => {
                                  this.getData(value);
                                }}
                              >
                                {value.name
                                  ? value.name
                                  : ""}
                              </span>{" "}
                              <span
                                style={{
                                  float: "right",
                                  color: "black",
                                  fontWeight: "bold",
                                }}
                              >
                                {value.category ? value.category : ""}
                              </span>
                              <br />
                              <small>
                                {value.user_email ? value.user_email : ""}
                              </small>
                              <br />
                              <small>
                                Added: {value.created ? value.created : ""}
                              </small>
                              <br />
                              <b style={{ wordWrap: "break-word" }}>
                                {value.social_post_link}
                              </b>
                            </div>
                          </a>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
            {this.state.loadMoreDisplay && (
              <button
                style={{
                  position: "relative",
                  left: "50%",
                  transform: "translateX(-50%)",
                  padding: "10px 18px",
                }}
                type="button"
                onClick={this.loadMoreData}
              >
                Load More
              </button>
            )}

            {this.state.popup && (
              <div className="popup">
                <div className="kamal_list_popup">
                  <h3 className="story_heading">
                    Detail
                    <span
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        this.setState({ popup: false });
                      }}
                    >
                      &times;
                    </span>
                  </h3>

                  <div
                    style={{
                      marginTop: "20px",
                      textAlign: "center",
                      marginBottom: "20px",
                    }}
                  >
                    <form onSubmit={this.submitForm}>
                      <div>
                        <label htmlFor="selectItem">Select a Category</label>
                        <select
                          id="selectItem"
                          value={this.state.selectValue}
                          style={{
                            width: "200px",
                            marginLeft: "20px",
                            padding: "5px 15px",
                          }}
                          onChange={(e) => {
                            this.setState({ selectValue: e.target.value });
                            console.log(e.target.id);
                            console.log(e);
                          }}
                        >
                          <option value="">Select a Category</option>
                          <option value="Param Pushp">Param Pushp</option>
                          <option value="Popular">Popular</option>
                          <option value="Emergency">Emergency</option>
                          <option value="Women">Women</option>
                        </select>
                        <button
                          style={{
                            marginTop: "30px",
                            marginLeft: "20px",
                            padding: "5px 10px",
                            borderRadius: "5px",
                            border: "none",
                            backgroundColor: "blue",
                            color: "white",
                          }}
                          type="submit"
                        >
                          Save
                        </button>
                      </div>
                    </form>
                  </div>
                  <div style={{ textAlign: "center" }}>
                    <img
                      src={this.state.Data.canvasImage}
                      style={{ width: "400px" }}
                    />
                  </div>

                  {this.state.Data &&
                    this.state.Data.nominee_description &&
                    !(
                      this.state.Data.nominee_description.split(" ").join("")
                        .length <= 8
                    ) && (
                      <div>
                        <h3 className="story_heading">Story </h3>

                        <div
                          dangerouslySetInnerHTML={{
                            __html: this.state.Data.nominee_description,
                          }}
                        ></div>
                      </div>
                    )}
                  {this.state.Data &&
                    this.state.Data.nominee_potos &&
                    this.state.Data &&
                    this.state.Data.nominee_potos &&
                    JSON.parse(this.state.Data.nominee_potos).length > 0 && (
                      <div>
                        <h3 className="story_heading">Nominee's Photos</h3>
                        <div className="img_box">
                          {JSON.parse(this.state.Data.nominee_potos).map(
                            (val) => {
                              return (
                                <div className="img_content">
                                  <img src={val} />
                                </div>
                              );
                            }
                          )}
                        </div>
                      </div>
                    )}

                  {this.state.Data &&
                    this.state.Data.nominee_work_videos &&
                    JSON.parse(this.state.Data.nominee_work_videos).length >
                    0 && (
                      <div>
                        <h3
                          className="story_heading"
                          style={{ marginTop: "20px" }}
                        >
                          Nominee's Videos
                        </h3>
                        <div className="img_box">
                          {JSON.parse(this.state.Data.nominee_work_videos).map(
                            (val) => {
                              return (
                                <div className="video_content">
                                  <video
                                    autoload
                                    controls
                                    className="video_width"
                                    style={{ padding: "10px" }}
                                  >
                                    <source src={val} />
                                  </video>
                                </div>
                              );
                            }
                          )}
                        </div>
                      </div>
                    )}
                  {this.state.Data &&
                    this.state.Data.nominee_links &&
                    JSON.parse(this.state.Data.nominee_links).length > 0 && (
                      <div>
                        <h3
                          className="story_heading"
                          style={{ marginTop: "20px" }}
                        >
                          Nominee's Links
                        </h3>
                        <div className="img_box">
                          {JSON.parse(this.state.Data.nominee_links).map(
                            (val) => {
                              return (
                                <ul className="video_conte">
                                  <li>
                                    {" "}
                                    <a href={val} target="_blank">
                                      {val}
                                    </a>
                                  </li>
                                </ul>
                              );
                            }
                          )}
                        </div>
                      </div>
                    )}
                </div>
              </div>
            )}

            {this.state.setPopup && (
              <div className="popup">
                <div className="kamal_list_popup">
                  <h3 className="story_heading">
                    Set Category
                    <span
                      style={{ cursor: "pointer", marginLeft: "40px" }}
                      onClick={() => {
                        this.setState({ setPopup: false });
                      }}
                    >
                      &times;
                    </span>
                  </h3>
                  <div style={{ marginTop: "20px", textAlign: "center" }}>
                    <form onSubmit={this.submitForm}>
                      <div>
                        <label htmlFor="selectItem">Select a Category</label>
                        <select
                          id="selectItem"
                          value={this.state.selectValue}
                          style={{
                            width: "200px",
                            marginLeft: "20px",
                            padding: "5px 15px",
                          }}
                          onChange={(e) => {
                            this.setState({ selectValue: e.target.value });
                            console.log(e.target.id);
                            console.log(e);
                          }}
                        >
                          <option value="">Select a Category</option>
                          <option value="Param Pushp">Param Pushp</option>
                          <option value="My State">My State</option>
                          <option value="Popular">Popular</option>
                          <option value="Emergency">Emergency</option>
                          <option value="Women">Women</option>
                        </select>
                      </div>

                      <div>
                        <button
                          style={{
                            marginTop: "30px",
                            padding: "5px 10px",
                            borderRadius: "5px",
                            border: "none",
                            backgroundColor: "blue",
                            color: "white",
                          }}
                          type="submit"
                        >
                          Save
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
                <div className="story_heading"></div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/KamalPushpa/Moderation.jsx